'use strict';

var TAB = '\t';
exports.TAB = TAB;
var ENTER = '\n';
exports.ENTER = ENTER;
var SPACE = ' ';
exports.SPACE = SPACE;